import { Serializable } from '@admin/core/models/serializable';
import { InvoiceActionResultType } from '@admin/billing/invoices/shared/models/invoice-action-result-type';

export class InvoiceActionResult implements Serializable<InvoiceActionResult> {
  fromObject(object: any): InvoiceActionResult {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public resultType: InvoiceActionResultType;
  public isMulti: boolean;
  public errorMessages: { [index: number]: string };
  public displayMessage: string;
}
